import { FC } from 'react'
import Image from 'next/image'

export interface SceneCardProps {
  img: string
  title: string
  desc: string
  list: { icon: string; desc: string }[]
}

export type TSceneCard = SceneCardProps

const SceneCard: FC<SceneCardProps> = ({ img, title, desc, list }) => {
  return (
    <div
      className={[
        'w-full flex border-BBC3CE',
        'flex-col py-8',
        'laptop:flex-row laptop:px-8 laptop:py-12 laptop:border',
      ].join(' ')}
    >
      <div className="w-327px h-327px laptop:w-422px laptop:h-422px">
        <Image
          alt="scene image"
          src={img}
          width="422"
          height="422"
          className="!w-327px !h-327px !laptop:w-422px !laptop:h-422px"
          objectFit="cover"
        />
      </div>

      <div className="flex flex-col flex-1 mt-26px laptop:mt-0 laptop:pl-8">
        <div className="laptop:h-182px ">
          <h4 className="text-20 laptop:text-24 text-black/90 font-semibold">{title}</h4>
          <p className="text-sm laptop:text-base text-black/60 font-normal mt-3 laptop:mt-4">{desc}</p>
        </div>

        <ul className="flex flex-row flex-wrap mt-8 laptop:mt-0 gap-x-3 gap-y-6 laptop:gap-x-8 laptop:gap-y-50px">
          {list.map((item, index) => (
            <li key={item.desc + index} className="flex flex-col items-start laptop:flex-row laptop:items-center">
              <Image
                alt={item.desc}
                src={item.icon}
                width="48"
                height="48"
                className="!w-12 !h-12 !laptop:w-12 !laptop:h-12"
              />
              <p className="text-black/90 font-semibold mt-3 laptop:mt-0 text-sm laptop:text-sm w-157px laptop:w-150px">
                {item.desc}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default SceneCard
